import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
 getUsers () {
   return Api().get("/users?page=0&size=10000");
},
  // Método que llama a la url para crear un chat
  getUsersClients () {
    return Api().get("/users-clients/");
  },
  getUsersClientsData () {
    return Api().get("/users-clients-data/");
  },
  getUserForAdmin () {
    return Api().get("/users-for-admin/");
  },
  updateUser (params) {
    return Api().put("/users/",params);
  },
  addUser (params) {
    return Api().post("/users/",params);
  },
  getUser (params) {
    return Api().get("/users/"+params);
  },
  deleteUser (params) {
    return Api().delete("/users/"+params);
  },
  getRols () {
    return Api().get('/users/authorities')
  },
  getUsersReport(){
    return Api().get("/reports/user-logs")
  },
  getAllRoles () {
    return Api().get('/authorities')
  },

}



// WEBPACK FOOTER //
// ./src/services/UserService.js